import { useMediaQuery } from "native-base";
import React, { useState } from "react";
import MobileLandingPageBanner from "./mobileBanner";
import WebLandingPageBanner from "./webBanner";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import CventWebLandingPageBanner from "./cventWebBanner";
import CventMobileLandingPageBanner from "./cventMobileBanner";
import "./style.css";

const LandingPageBanner = ({ openModal, show = false }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [currentIndex, setCurrentIndex] = useState(0);

  const banners = MobileWindow
    ? [
        <MobileLandingPageBanner openModal={openModal} />,
        // <CventMobileLandingPageBanner />,
      ]
    : [
        <WebLandingPageBanner show={show} openModal={openModal} />,
        // <CventWebLandingPageBanner />,
      ];

  const nextBanner = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const prevBanner = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + banners.length) % banners.length
    );
  };

  return (
    <div style={{ position: "relative", width: "100%", overflow: "hidden" }}>
      <div style={{ position: "relative" }}>
        {banners[currentIndex]}
        <div className="indicator">
          {banners.map((_, index) => (
            <span
              key={index}
              // className={index === currentIndex ? "bubble active" : "bubble"}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
      {/* <div className="arrow left" onClick={prevBanner}></div>
      <div className="arrow right" onClick={nextBanner}></div> */}
    </div>
  );
};

export default LandingPageBanner;
